module.exports = __webpack_public_path__ + "static/media/ll1.994b967f.png";